/**
 * The base colors for the Soft UI Dashboard PRO React.
 * You can add new color using this file.
 * You can customized the colors for the entire Soft UI Dashboard PRO React using thie file.
 */

const colors = {
  background: {
    default: "#f8f9fa",
  },

  text: {
    main: "#3a3a3c",
    focus: "#444445",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#141414",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    shadow2: "#329aaa4b",
    shadow: "#329baa60",
    light: "#38abbc",
    main: "#329baa",
    focus: "#36aabb",
    background: "#E8EFF9",
  },

  pilotRefresher: {
    shadow2: "#32aa9a4b",
    shadow: "#32aa9861",
    light: "#38bcad",
    main: "#32aa98",
    dark: "#2c9171",
    focus: "#55b99d",
  },

  intro: {
    shadow: "#3270aa60",
    main: "#3270aa",
    dark: "#2c6091",
    focus: "#5589b9",
  },

  secondary: {
    shadow: "#8392ab90",
    main: "#8392ab",
    focus: "#96a2b8",
  },

  info: {
    main: "#329baa",
    focus: "#38a8b9",
  },

  success: {
    shadow: "#72b81a50",
    shadow2: "#71b81a70",
    main: "#72b81a",
    focus: "#71b025",
  },

  warning: {
    main: "#fbcf33",
    focus: "#fcd652",
    background: "#fef5d3",
  },

  maintenance: {
    main: "#fbcf33",
    light1: "#ffda56",
    light2: "#ffe586",
    light3: "#ffeaa0",
  },

  error: {
    main: "#ea0606",
    focus: "#c70505",
  },

  light: {
    main: "#e9ecef",
    focus: "#e9ecef",
  },

  dark: {
    shadow: "#48484890",
    main: "#3b3b3b",
    focus: "#5d5d5d",
  },

  border: {
    light: "#e0e0e0ff",
    dark: "#9c9c9cff",
  },

  grey: {
    100: "#f8f9fa",
    200: "#e9ecef",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#6c757d",
    700: "#495057",
    800: "#343a40",
    900: "#212529",
  },

  gradients: {
    primary: {
      main: "#329baa",
      state: "#76cad6",
    },

    secondary: {
      main: "#627594",
      state: "#a8b8d8",
    },

    info: {
      main: "#329baa",
      state: "#76cad6",
    },

    success: {
      main: "#17ad37",
      state: "#98ec2d",
    },

    warning: {
      main: "#f53939",
      state: "#fbcf33",
    },

    error: {
      main: "#ea0606",
      state: "#ff667c",
    },

    light: {
      main: "#ced4da",
      state: "#ebeff4",
    },

    white: {
      main: "#ffffff",
      state: "#ffffff",
    },

    dark: {
      main: "#141727",
      state: "#414141",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  alertColors: {
    primary: {
      main: "#329baa",
      state: "#76cad6",
      border: "#e0f7fb",
    },

    secondary: {
      main: "#627594",
      state: "#8ca1cb",
      border: "#dadee6",
    },

    info: {
      main: "#2152ff",
      state: "#02c6f3",
      border: "#b9ecf8",
    },

    success: {
      main: "#17ad37",
      state: "#84dc14",
      border: "#daf3b9",
    },

    warning: {
      main: "#f53939",
      state: "#fac60b",
      border: "#fef1c2",
    },

    error: {
      main: "#ea0606",
      state: "#ff3d59",
      border: "#f9b4b4",
    },

    light: {
      main: "#ced4da",
      state: "#d1dae6",
      border: "#f8f9fa",
    },

    dark: {
      main: "#141727",
      state: "#2c3154",
      border: "#c2c8d1",
    },
  },

  badgeColors: {
    primary: {
      background: "#e0f7fb",
      text: "#329baa",
    },

    secondary: {
      background: "#e4e8ed",
      text: "#5974a2",
    },

    info: {
      background: "#abe9f7",
      text: "#08a1c4",
    },

    success: {
      background: "#cdf59b",
      text: "#67b108",
    },

    warning: {
      background: "#fef5d3",
      text: "#fbc400",
    },

    error: {
      background: "#fc9797",
      text: "#bd0000",
    },

    light: {
      background: "#ffffff",
      text: "#c7d3de",
    },

    dark: {
      background: "#8097bf",
      text: "#1e2e4a",
    },
  },

  inputColors: {
    borderColor: {
      main: "#d2d6da",
      focus: "#35d1f5",
    },
    boxShadow: "#81e3f9",
    error: "#fd5c70",
    success: "#66d432",
  },

  sliderColors: {
    thumb: {
      borderColor: "#d9d9d9",
    },
  },

  circleSliderColors: {
    background: "#d3d3d3",
  },

  tabs: {
    indicator: {
      boxShadow: "#ddd",
    },
  },
};

export default colors;
